import { GRADABLE_MODELS_URL, SERIALS_URL } from "../../context/paths";

export const getSerials = async (token, modelId, serial, q) => {
    const searchOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        }
    }

    let queryUrl = SERIALS_URL;
    const params = new URLSearchParams();
    if (modelId) {
        params.append("modelId", modelId)
    }
    if (serial && !q) {
        params.append("serial", serial)
    }
    if (q) {
        params.append("q", q)
    }
    if (params) {
        queryUrl += "?" + params.toString();
    }

    try {
        const response = await fetch(queryUrl, searchOptions);
        return await response.json();
    } catch (error) {
        return {
            message: "Error retrieving serials",
            type: "error"
        }
    }

}

export const createSerial = async (token, body) => {
    const createOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
    }

    const CREATE_SERIAL_URL = `${SERIALS_URL}/add`;
    try {
        const response = await fetch(CREATE_SERIAL_URL, createOptions);
        return await response.json();
    } catch (error) {
        return {
            message: "Error creating serial",
            type: "error"
        }
    }
}

export const createSerialFromDraft = async (token, draftId) => {
    const createOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        }
    }

    const CREATE_SERIAL_URL = `${SERIALS_URL}/add/${draftId}`;
    try {
        const response = await fetch(CREATE_SERIAL_URL, createOptions);
        return await response.json();
    } catch (error) {
        return {
            message: "Error creating serial",
            type: "error"
        }
    }
}

export const createSerialDraft = async (token, productId, body) => {
    const createOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
    }

    const CREATE_SERIAL_DRAFT_URL = `${SERIALS_URL}/product/${productId}/drafts`;
    try {
        const response = await fetch(CREATE_SERIAL_DRAFT_URL, createOptions);
        return await response.json();
    } catch (error) {
        return {
            message: "Error creating serial",
            type: "error"
        }
    }
}

export const updateSerial = async (token, id, body) => {
    const updateOptions = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        },
        body: JSON.stringify(body)
    }
    const UPDATE_SERIAL_URL = `${SERIALS_URL}/update/${id}`;
    try {
        const response = await fetch(UPDATE_SERIAL_URL, updateOptions);
        return await response.json();
    } catch (error) {
        return {
            message: "Error updating serial",
            type: "error"
        }
    }
}

export const deleteSerial = async (token, id, isDraft) => {
    const deleteOptions = {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        }
    }
    const DELETE_SERIAL_URL = `${SERIALS_URL}/${isDraft ? "deletedraft" : "delete"}/${id}`;
    try {
        const response = await fetch(DELETE_SERIAL_URL, deleteOptions);
        return await response.json();
    } catch (error) {
        return {
            message: "Error updating serial",
            type: "error"
        }
    }
}

export const getSerialsByNumbers = async (token, serialNumbers) => {
    try {
        const response = await fetch(`${SERIALS_URL}/by-numbers`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({ serialNumbers }),
        });
        let body = null;
        try {
            body = await response.json();
        } catch (_err) {
            body = null;
        }
        if (!response.ok) {
            return {
                type: "error",
                message: body?.message || `Erro no lookup de seriais (${response.status})`,
            };
        }
        return body || { type: "success", found: [], missing: [] };
    } catch (error) {
        return {
            type: "error",
            message: error?.message || "Erro no lookup de seriais",
        };
    }
};

export const saveManualTagEmissions = async (token, data) => {
    try {
        const response = await fetch(`${SERIALS_URL}/manual-tag-emissions`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({ data }),
        });
        let body = null;
        try {
            body = await response.json();
        } catch (_err) {
            body = null;
        }
        if (!response.ok) {
            return {
                type: "error",
                message: body?.message || `Erro ao registrar etiquetas manuais (${response.status})`,
            };
        }
        return body || { type: "success", message: "Manual tag emissions registered" };
    } catch (error) {
        return {
            type: "error",
            message: error?.message || "Erro ao registrar etiquetas manuais",
        };
    }
};

export const saveModelsTags = async (token, tagsData) => {
    try {
        const postOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ data: tagsData })
        }
        const SAVE_MODELS_TAGS__URL = `${GRADABLE_MODELS_URL}/tags`;
        const response = await fetch(SAVE_MODELS_TAGS__URL, postOptions);
        let body = null;
        try {
            body = await response.json();
        } catch (_err) {
            body = null;
        }
        if (!response.ok) {
            const timeoutHint =
                response.status === 504 || response.status === 408
                    ? "Tempo esgotado ao salvar as etiquetas. Tente de novo ou em lotes menores."
                    : null;
            return {
                message:
                    body?.message ||
                    timeoutHint ||
                    `Erro ao salvar etiquetas (${response.status})`,
                type: "error",
                data: body?.data,
            };
        }
        return body || { type: "success", message: "Tags added to models" };
    } catch (error) {
        const raw = error?.message || "";
        const isFetchFail = /failed to fetch|networkerror|load failed/i.test(raw);
        return {
            message: isFetchFail
                ? "Falha de rede ao salvar etiquetas (possível timeout). Tente de novo ou em lotes menores."
                : raw || "Error updating serial",
            type: "error"
        }
    }
}

export const generateTags = async (token, data) => {
    try {
        const GENERATE_TAGS_URL = `${SERIALS_URL}/tags/generate`;
        const postOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ "data": data })
        }
        const response = await fetch(GENERATE_TAGS_URL, postOptions);
        return response;
    } catch (error) {
        return {
            message: "Error generating tags",
            type: "error"
        }
    }
}

const parseJsonIfNeeded = (value) => {
    if (typeof value !== "string") {
        return value;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        return value;
    }
}

const getLambdaMessage = (body, fallback) => {
    if (body?.message) {
        return body.message;
    }
    if (body?.error) {
        return body.error;
    }
    if (typeof body === "string" && body.trim()) {
        return body;
    }
    return fallback;
}

const isValidHttpsUrl = (value) => {
    if (!value || typeof value !== "string") {
        return false;
    }

    try {
        const parsedUrl = new URL(value);
        return parsedUrl.protocol === "https:";
    } catch (error) {
        return false;
    }
}

const downloadFromUrl = (url) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = 'etiquetas.zip';
    a.click();
}

export const downloadBlob = (blob, filename = "etiquetas.zip") => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}

export const triggerLambda = async (token, payload) => {

    try {
        const response = await generateTags(token, payload);
        if (!response || response?.type === "error" || typeof response?.ok !== "boolean") {
            return {
                type: "error",
                data: null,
                message: response?.message || "Erro ao gerar etiquetas"
            }
        }

        const contentType = response.headers?.get("content-type")?.toLowerCase() || "";
        const isJsonResponse = contentType.includes("application/json") || contentType.includes("text/json");

        if (isJsonResponse) {
            let jsonResponse = null;
            try {
                jsonResponse = await response.json();
            } catch (error) {
                return {
                    type: "error",
                    data: null,
                    message: "Resposta inválida ao gerar etiquetas"
                }
            }

            const parsedResponse = parseJsonIfNeeded(jsonResponse);
            const responseBody = parseJsonIfNeeded(parsedResponse?.body ?? parsedResponse?.data ?? parsedResponse);
            const statusCode = parsedResponse?.statusCode ?? response.status;

            if (statusCode !== 200) {
                return {
                    type: "error",
                    data: responseBody,
                    message: getLambdaMessage(responseBody, "Erro ao gerar etiquetas")
                }
            }

            if (responseBody?.download_url) {
                if (!isValidHttpsUrl(responseBody.download_url)) {
                    return {
                        type: "error",
                        data: responseBody,
                        message: "URL de download inválida. Tente novamente."
                    }
                }

                downloadFromUrl(responseBody.download_url);
                return {
                    type: "success",
                    data: responseBody,
                    message: getLambdaMessage(responseBody, "Etiquetas geradas!")
                }
            }

            if (parsedResponse?.isBase64Encoded && typeof responseBody === "string" && responseBody) {
                downloadBlob(b64toBlob(responseBody, 'application/zip'));
                return {
                    type: "success",
                    data: responseBody,
                    message: getLambdaMessage(responseBody, "Etiquetas geradas!")
                }
            }

            return {
                type: "error",
                data: responseBody,
                message: "Não foi possível localizar o arquivo de etiquetas para download."
            }
        }

        if (!response.ok) {
            return {
                type: "error",
                data: null,
                message: "Erro ao gerar etiquetas"
            }
        }

        const blob = await response.blob();
        if (!blob || blob.size === 0) {
            return {
                type: "error",
                data: null,
                message: "Não foi possível localizar o arquivo de etiquetas para download."
            }
        }

        downloadBlob(blob);
        return {
            type: "success",
            data: null,
            message: "Etiquetas geradas!"
        }
    } catch (error) {
        return {type: "error", data: null, message: error?.message || "Erro ao gerar etiquetas"}
    }
  };

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  };
